/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Preset_WeekInputs */

const vi_warehouse_sales_preset_week = /** @type {(inputs: Warehouse_Sales_Preset_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuần này`)
};

/**

* @param {Warehouse_Sales_Preset_WeekInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_preset_week = /** @type {((inputs?: Warehouse_Sales_Preset_WeekInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Preset_WeekInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_preset_week(inputs)
});